export const ENGLISH_LANGUAGE_TESTS = ['celpip', 'ielts', 'pte'];
export const FRENCH_LANGUAGE_TESTS = ['tef', 'tcf'];

export const isEnglishLanguageTest = (test) => ENGLISH_LANGUAGE_TESTS.includes(test);
export const isFrenchLanguageTest = (test) => FRENCH_LANGUAGE_TESTS.includes(test);

const minimumLanguageLevel = (skills = {}) => {
  const levels = ['reading', 'writing', 'speaking', 'listening']
    .map((skill) => Number(skills[skill]) || 0);

  return Math.min(...levels);
};

export const calculateSecondOfficialLanguagePoints = (skills, hasSpouse) => {
  const points = Object.values(skills).reduce((sum, level) => {
    const clb = Number(level) || 0;
    if (clb < 5) return sum;
    if (clb <= 6) return sum + 1;
    if (clb <= 8) return sum + 3;
    return sum + 6;
  }, 0);

  return Math.min(points, hasSpouse ? 22 : 24);
};

export const combineTransferabilityPairings = (firstPairing, secondPairing) =>
  Math.min((Number(firstPairing) || 0) + (Number(secondPairing) || 0), 50);

export const calculateFrenchAdditionalPoints = ({
  firstLanguageTest,
  secondLanguageTest,
  languageFirst,
  languageSecond
}) => {
  const frenchSkills = isFrenchLanguageTest(firstLanguageTest)
    ? languageFirst
    : isFrenchLanguageTest(secondLanguageTest)
      ? languageSecond
      : null;

  if (!frenchSkills || minimumLanguageLevel(frenchSkills) < 7) return 0;

  const englishSkills = isEnglishLanguageTest(firstLanguageTest)
    ? languageFirst
    : isEnglishLanguageTest(secondLanguageTest)
      ? languageSecond
      : null;

  return englishSkills && minimumLanguageLevel(englishSkills) >= 5 ? 50 : 25;
};

export const capAdditionalPoints = (points) =>
  Math.min(Math.max(Number(points) || 0, 0), 600);

export const convertPTECoreToCLB = (score, skill) => {
  const value = Number(score) || 0;
  const thresholds = {
    reading: [[88, 10], [78, 9], [69, 8], [60, 7], [51, 6], [42, 5], [33, 4]],
    writing: [[90, 10], [88, 9], [79, 8], [69, 7], [60, 6], [51, 5], [41, 4]],
    speaking: [[89, 10], [84, 9], [76, 8], [68, 7], [59, 6], [51, 5], [42, 4]],
    listening: [[89, 10], [82, 9], [71, 8], [60, 7], [50, 6], [39, 5], [28, 4]]
  };

  const skillThresholds = thresholds[skill] || [];
  const match = skillThresholds.find(([minimum]) => value >= minimum);
  return match ? match[1] : 0;
};

export const CANADIAN_EDUCATION_REQUIREMENT_KEYS = [
  'languageStudyLimit',
  'noReturnAward',
  'schoolInCanada',
  'fullTimeEightMonths',
  'presentInCanadaEightMonths'
];

export const meetsCanadianEducationRequirements = (requirements = {}) =>
  CANADIAN_EDUCATION_REQUIREMENT_KEYS.every((key) => requirements[key] === true);
